import { hookstate } from '@hookstate/core'

const globalGeneralSurveyStore = hookstate({
});

export default globalGeneralSurveyStore;